import { useEffect, useRef } from "react";
import mapboxgl from "mapbox-gl";

export default function Marker({ map, longitude, latitude }) {
  const markerRef = useRef(null);

  useEffect(() => {
    if (!map) return;

    markerRef.current = new mapboxgl.Marker()
      .setLngLat([longitude, latitude])
      .addTo(map);

    return () => markerRef.current?.remove();
  }, [map]);

  useEffect(() => {
    markerRef.current?.setLngLat([longitude, latitude]);
  }, [longitude, latitude]);

  return null;
}

